import {Add} from '@mui/icons-material';
import {
    Backdrop,
    Box,
    Button,
    DialogActions,
    Fade,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    SelectChangeEvent,
    Typography,
} from '@mui/material';
import {useState} from 'react';
import {SectionType, Status} from '../../../api/models';
import {buildStringFromSectionType} from '../../../common/utils';
import {useUpdateWebsiteStructure} from '../../../api';

interface AddNewSectionDashboardPanelSectionItemProps {
    refetch: VoidFunction;
    missingSections: SectionType[];
    throwSnackbarMessage: (message: string) => void;
}

export const AddNewSectionDashboardPanelSectionItem = (props: AddNewSectionDashboardPanelSectionItemProps) => {
    const [open, setOpen] = useState(false);
    const [selectedNewSection, updateSelectedNewSection] = useState<SectionType | undefined>(undefined);
    const {refetch, missingSections} = props;
    const {mutateWebsiteStructure} = useUpdateWebsiteStructure();

    const handleClose = () => {
        setOpen(false);
    };

    const addNewSection = async () => {
        if (selectedNewSection) {
            mutateWebsiteStructure({
                data: {
                    editWebsiteRequestDTO: {
                        updates: [
                            {
                                sectionType: selectedNewSection,
                                status: Status.ACTIVE,
                            },
                        ],
                    },
                    cb: refetch,
                },
                throwSnackbarMessage: (message) => props.throwSnackbarMessage(message),
            });
        } else {
        }
    };

    return (
        <>
            <div
                onClick={() => {
                    // open modal to add new section
                    setOpen(true);
                }}
                style={{
                    paddingTop: 6,
                    cursor: 'pointer',
                    textDecorationLine: 'underline',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <Box display={'flex'} flexDirection={'row'}>
                    <Add />
                    <Typography
                        style={{
                            fontWeight: 700,
                            color: 'black',
                            fontSize: '14px'
                        }}
                        variant='body1'
                        noWrap
                        component='div'>
                        Add New Section
                    </Typography>
                </Box>
            </div>
            <div>
                <Modal
                    aria-labelledby='transition-modal-title'
                    aria-describedby='transition-modal-description'
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    slots={{backdrop: Backdrop}}
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}>
                    <Fade in={open}>
                        <Box
                            sx={{
                                position: 'absolute' as 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'white',
                                boxShadow: 24,
                                borderRadius: 2,
                                paddingLeft: 4,
                                paddingRight: 4,
                                paddingTop: 4,
                                paddingBottom: 2,
                            }}>
                            <Typography id='transition-modal-title' variant='h6' component='h2'>
                                Add new section
                            </Typography>
                            <Typography id='transition-modal-description' sx={{mt: 2}}>
                                Add new section to the website from the following options
                            </Typography>
                            <br />
                            <FormControl fullWidth>
                                <InputLabel id='new-section-select-label'>New Section</InputLabel>
                                <Select
                                    labelId='new-section-select-label'
                                    id='new-section-select'
                                    value={selectedNewSection}
                                    label='New Section'
                                    onChange={(handleChange: SelectChangeEvent) => {
                                        updateSelectedNewSection(handleChange.target.value as SectionType);
                                    }}>
                                    {missingSections.map((e: SectionType) => {
                                        return <MenuItem value={e}>{buildStringFromSectionType(e)} Section</MenuItem>;
                                    })}
                                </Select>
                            </FormControl>
                            <br />
                            <br />

                            <DialogActions>
                                <Button onClick={addNewSection}>Save changes</Button>
                                <Button onClick={handleClose}>Dismiss</Button>
                            </DialogActions>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </>
    );
};
